<div class="ppl-spinner">
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
</div>
